/* eslint-disable*/
import React, { useEffect } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import { currentchannel } from 'feactures/channel/channelSlice';
import { userinfo } from 'feactures/user/userSlice';
import {
  amazonFavoriteCategory,
  rakutenFavoriteCategory,
  yahooFavoriteCategory,
  fetchFavoriteCategory,
  updateFavoriteCategory,
  setSelectedFavoriteCategory,
  selectedFavoriteCategory,
  selectedFavoriteCategoryAmazon,
  selectedFavoriteCategoryRakuten,
  selectedFavoriteCategoryYahoo
} from 'feactures/category/favoriteCategorySlice';
import {
  amazonParentFavoriteCategory,
  rakutenParentFavoriteCategory,
  yahooParentFavoriteCategory,
  fetchParentFavoriteCategory
} from 'feactures/category/parentFavoriteCategorySlice';
import {
  currentAmazonCategoryList,
  currentRakutenCategoryList,
  currentYahooCategoryList
} from 'feactures/category/categoryGraphSlice';

import { useDispatch, useSelector } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { makeStyles } from '@material-ui/styles';
import theme from 'theme';
{
  /* <div class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-colorSelectBox MuiInputBase-formControl makeStyles-customSelect-95 css-92pga8-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root"><div tabindex="0" role="button" aria-expanded="false" aria-haspopup="listbox" aria-label="Without label" class="MuiSelect-select MuiSelect-outlined MuiInputBase-input MuiOutlinedInput-input css-10l5tdt-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input"><span class="notranslate">​</span></div><input aria-hidden="true" tabindex="-1" class="MuiSelect-nativeInput css-yf8vq0-MuiSelect-nativeInput" value="[object Object]"><svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSelect-icon MuiSelect-iconOutlined css-6r42io-MuiSvgIcon-root-MuiSelect-icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ArrowDropDownIcon"><path d="M7 10l5 5 5-5z"></path></svg><fieldset aria-hidden="true" class="MuiOutlinedInput-notchedOutline css-1d3z3hw-MuiOutlinedInput-notchedOutline"><legend class="css-ihdtdm"><span class="notranslate">​</span></legend></fieldset></div> */
}

const useStyles = makeStyles({
  customSelect: {
    color: '#575757',
    transition: theme.transitions.create('background-color'),
    '&:hover': {
      backgroundColor: '#E6E6E6'
    }
  },
  formControl: {
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.grey[400],
        borderWidth: 1
      }
    },
    '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.grey[400]
    }
  }
});

const FavoriteCategoryPullDown = (props) => {
  const { page } = props;
  const channel = useSelector(currentchannel);
  const userInfo = useSelector(userinfo);
  const favoriteCategory = useSelector(selectedFavoriteCategory);
  const selectedAmazonFavo = useSelector(selectedFavoriteCategoryAmazon);
  const selectedRakutenFavo = useSelector(selectedFavoriteCategoryRakuten);
  const selectedYahooFavo = useSelector(selectedFavoriteCategoryYahoo);
  const favoriteAmazonCategory = useSelector(amazonFavoriteCategory);
  const favoriteRakutenCategory = useSelector(rakutenFavoriteCategory);
  const favoriteYahooCategory = useSelector(yahooFavoriteCategory);
  const parentFavoriteAmazonCategory = useSelector(
    amazonParentFavoriteCategory
  );
  const parentFavoriteRakutenCategory = useSelector(
    rakutenParentFavoriteCategory
  );
  const parentFavoriteYahooCategory = useSelector(yahooParentFavoriteCategory);

  // 現在選択中のカテゴリ
  const currentSelectAmazonCategories = useSelector(currentAmazonCategoryList);
  const currentSelectRakutenCategories = useSelector(
    currentRakutenCategoryList
  );
  const currentSelectYahooCategories = useSelector(currentYahooCategoryList);
  const dispatch = useDispatch();

  // 現在選択中のカテゴリを格納
  let currentSelectCategoryList = [];
  if (channel == 1) {
    currentSelectCategoryList = currentSelectAmazonCategories;
  } else if (channel == 2) {
    currentSelectCategoryList = currentSelectRakutenCategories;
  } else if (channel == 3) {
    currentSelectCategoryList = currentSelectYahooCategories;
  }

  // 現在選択中のお気に入りカテゴリ
  let currentSelectedFavoriteCategory = { label: null, value: null };
  if (channel == 1) {
    currentSelectedFavoriteCategory = selectedAmazonFavo;
  } else if (channel == 2) {
    currentSelectedFavoriteCategory = selectedRakutenFavo;
  } else if (channel == 3) {
    currentSelectedFavoriteCategory = selectedYahooFavo;
  }

  const categoriesByChannel = {
    1: favoriteAmazonCategory,
    2: favoriteRakutenCategory,
    3: favoriteYahooCategory
  };

  const currentFavoriteCategories = categoriesByChannel[channel];
  // 選択されたカテゴリがお気に入り登録されていない場合、お気に入り選択を外す必要がある
  let lastElement;

  // 現在選択中のカテゴリの最も階層が低いものをlastElementとする
  for (let i = currentSelectCategoryList.length - 1; i >= 0; i--) {
    if (currentSelectCategoryList[i] !== 0) {
      lastElement = currentSelectCategoryList[i];
      break;
    }
  }
  useEffect(async () => {
    if (!lastElement) return;
    let matchingItem = { label: null, value: null };
    // lastElementがお気に入り登録されていればそれをmatchingItemとする
    currentFavoriteCategories.forEach((item) => {
      if (item.value === lastElement.value) {
        matchingItem = item;
      }
    });
    // currentSelectCategoryListの方もparentFavoriteCategoryでuseEffectしているので、無限ループにならないようにreturn条件を追加
    if (currentSelectedFavoriteCategory.value == matchingItem.value) return;

    //　lastElementがお気に入り登録されていればそれをお気に入り選択し、されていなければお気に入り選択を外す(parentCategoryもリセット)
    if (matchingItem.value !== null) {
      dispatch(setSelectedFavoriteCategory({ cate: matchingItem, channel }));
    } else {
      dispatch(setSelectedFavoriteCategory({ cate: '', channel }));
      try {
        const fetchResult = await dispatch(
          fetchParentFavoriteCategory({
            categoryId: null
          })
        );
        if (fetchParentFavoriteCategory.fulfilled.match(fetchResult)) {
          // console.log(fetchResult.payload); // successful return value here!
        } else {
          // console.log(fetchResult.error); // error info here if it failed
        }
      } catch (error) {
        console.log(error);
      }
    }
    // currentSelectCategoryListの方もparentFavoriteCategoryでuseEffectしているので、無限ループにならないようにreturn条件を追加
    // if (currentSelectedFavoriteCategory == matchingItem) return;

    // reduxの方で管理しているstateも再取得
    try {
      const fetchResult = await dispatch(
        fetchParentFavoriteCategory({
          categoryId: matchingItem.value
        })
      );
      if (fetchParentFavoriteCategory.fulfilled.match(fetchResult)) {
        // console.log(fetchResult.payload); // successful return value here!
      } else {
        // console.log(fetchResult.error); // error info here if it failed
      }
    } catch (error) {
      console.log(error);
    }
  }, [lastElement]);

  const handleChange = async (event) => {
    dispatch(
      setSelectedFavoriteCategory({ cate: event.target.value, channel })
    );
    try {
      const fetchResult = await dispatch(
        fetchParentFavoriteCategory({
          categoryId: event.target.value.value
        })
      );
      if (fetchParentFavoriteCategory.fulfilled.match(fetchResult)) {
        // console.log(fetchResult.payload); // successful return value here!
      } else {
        // console.log(fetchResult.error); // error info here if it failed
      }
    } catch (error) {
      console.log(error);
    }
  };

  const classes = useStyles();

  return (
    <FormControl
      sx={{ width: 150, height: 30 }}
      className={classes.formControl}
    >
      <Select
        className={classes.customSelect}
        value={currentSelectedFavoriteCategory}
        onChange={handleChange}
        displayEmpty
        inputProps={{ 'aria-label': 'Without label' }}
        disabled={page === 'productMeasures'}
        sx={{ height: 30, bgcolor: '#FFFFFF', fontSize: '14px' }}
      >
        <MenuItem value=""></MenuItem>
        {currentFavoriteCategories.map((cat, index) => {
          return (
            <MenuItem value={cat} key={index}>
              {cat.label}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default FavoriteCategoryPullDown;
